<form
  [formGroup]="editForm"
  [ngClass]="{ loading: saving }"
  (ngSubmit)="update(editForm)"
  data-test-id="edit-notification-frequency-form"
  novalidate
>
  <div class="header">
    <h4 class="font-bold">Notification preferences</h4>
  </div>
  <div class="form-group">
    <mat-label>Show me notifications</mat-label>
    <ng-select
      [clearable]="false"
      [items]="frequencyOptions"
      bindLabel="long"
      bindValue="value"
      class="frequency-select"
      data-test-id="edit-notification-frequency-select"
      formControlName="frequency"
      placeholder="Frequency"
    ></ng-select>
    <validation-messages
      [field]="editForm.get('frequency')"
      [form]="editForm"
      [messages]="['required']"
      [texts]="{ required: 'Please select a frequency' }"
      data-test-id="edit-notification-frequency-select-validationMessage"
    ></validation-messages>
    <validation-messages
      [field]="editForm"
      [form]="editForm"
      [messages]="['serverError']"
      data-test-id="edit-notification-frequency-select-serverError-validationMessage"
    ></validation-messages>
  </div>
  <div class="form-actions">
    <button
      [loading]="saving"
      class="save-button"
      color="accent"
      data-test-id="edit-notification-frequency-save-button"
      mat-stroked-button
      type="submit"
    >
      {{
        (mediaQueryService.breakpoints$ | async).ltMd
          ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE
          : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP
      }}
    </button>
    <button
      (click)="cancel()"
      class="cancel-button"
      color="accent"
      data-test-id="edit-notification-frequency-discard-button"
      mat-button
      type="button"
    >
      {{
        (mediaQueryService.breakpoints$ | async).ltMd
          ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
          : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
      }}
    </button>
  </div>
</form>
